export const config = {
    termsLocalStorageKey: 'terms_admin_accepted',
    clientPortalUrl: 'https://client.modernhealth.com/',
    clientPortalPassword: 'Life-in-m0t1on!',
    lookerTermsUpdated:
        'https://assets.joinmodernhealth.com/HRTO/reporting/reporting-terms-of-use-07302021.pdf',
    lookerTermsPrior:
        'https://assets.joinmodernhealth.com/HRTO/reporting/reporting-terms-of-use.pdf',
    csmMail: 'clients@joinmodernhealth.com',
    contactUs: 'https://support.modernhealth.com/hc/en-us/requests/new',
    adminUrl: 'https://my.joinmodernhealth.com/admin',
};
